import React from 'react';
type Tome = {
  number: string;
  title: string;
  range: string;
  promise: string;
  badge: string;
  badgeText: string;
  flag?: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'Foundations & Ball Control',
  range: 'Sessions 1–9',
  promise: 'Put the system in place and give your whole team a first contact they can repeat.',
  badge: 'bg-coral',
  badgeText: 'text-white',
  flag: 'Start here',
  contents: ['The Session Formula: how one practice runs itself', 'Passing posture, platform and movement', 'Serving it in, every time', 'Ball-control games that double as your warm-up']
}, {
  number: '02',
  title: 'Serving & Serve-Receive',
  range: 'Sessions 10–18',
  promise: 'Serves that land under pressure and a serve-receive that passes to target.',
  badge: 'bg-indigo',
  badgeText: 'text-white',
  contents: ['Targeted and float serving', 'The 3-passer receive that beats the 5', 'Read the server, own your seam', 'Pass-to-target ladders by rotation']
}, {
  number: '03',
  title: 'Setting & Attacking',
  range: 'Sessions 19–27',
  promise: 'A set your hitters can swing on, and a real approach-and-swing.',
  badge: 'bg-teal',
  badgeText: 'text-white',
  contents: ['Setter hands, footwork and the release', 'The 4-step approach and arm swing', 'Hitting lines, tips and shots', 'First-tempo timing and connection']
}, {
  number: '04',
  title: 'Team Systems & Rotations',
  range: 'Sessions 28–36',
  promise: 'Turn six players into one system you can run tomorrow.',
  badge: 'bg-amber',
  badgeText: 'text-ink',
  contents: ['Serve-receive base and all six rotations', 'Running a 6-2 and a 5-1 — overlap-legal', 'Transition, free-ball and down-ball', 'Switches, overlap checks and the pocket Field Card']
}, {
  number: '05',
  title: 'Blocking & Defense',
  range: 'Sessions 37–45',
  promise: 'Block, dig and turn defense into your next attack.',
  badge: 'bg-coral',
  badgeText: 'text-white',
  contents: ['Block footwork and timing at the net', 'Perimeter and rotational defense', 'Digging and platform under pressure', 'Transition from the dig to the swing']
}, {
  number: '06',
  title: 'Compete & Season',
  range: 'Sessions 46–52',
  promise: 'Scoring scrimmages, broken-play reps and the tools to run the whole season.',
  badge: 'bg-indigo',
  badgeText: 'text-white',
  contents: ['Wash and 6v6 scoring games', 'Situational and broken-play practice', 'Tryouts and assessment stations', 'The keep-it-simple plan for next season']
}];
const everyVolume = ['Weekly sessions as a Run Sheet + Drill Cards', 'A worksheet you print and reuse, one per session', 'The Session Formula for 45, 60 and 90–120-minute slots', 'Coach’s Notes, Quick Wins and by-level progressions'];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-white text-ink" data-id="element-407" data-mp="11lbilahxifrn">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-408" data-mp="11neg0flevb6e">
        <div className="text-center" data-id="element-409" data-mp="16l6anhdfxbea">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-indigo" data-id="element-410" data-mp="1am9ojybxgxcv">Your whole year</p>
          <h2 id="tomes-heading" className="mt-3 font-display text-3xl font-extrabold text-ink sm:text-5xl" data-id="element-411" data-mp="dw93a9aroz0b">
            Inside the pack — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-slate" data-id="element-412" data-mp="ivc1paw8s6zb">
            52 weekly sessions in the order you coach them, each volume building on
            the last. One team? Work through it across the season. Several teams?
            Open the volume that fits each group&apos;s level.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-413" data-mp="3vch71t1mhzni">
          {tomes.map(tome => <article key={tome.number} className={`flex flex-col rounded-2xl border bg-white p-6 shadow-soft ${tome.flag ? 'border-coral ring-1 ring-coral' : 'border-cloud-dark'}`} data-id="element-414" data-mp="3c7m4bvvj6ve3">
              <div className="flex items-center gap-2.5" data-id="element-415" data-mp="3lz01hx00fj42">
                <span className={`flex h-9 w-9 items-center justify-center rounded-full font-display text-base font-extrabold ${tome.badge} ${tome.badgeText}`} data-id="element-416" data-mp="3h6oyumdvxj7t">
                  {tome.number}
                </span>
                <span className="text-[11px] font-semibold uppercase tracking-widest text-slate" data-id="element-417" data-mp="3pyh66o7m4c86">Volume {tome.number}</span>
                {tome.flag && <span className="ml-auto rounded-full bg-coral px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-418" data-mp="3sbw0611stxv">
                    {tome.flag}
                  </span>}
              </div>
              <h3 className="mt-3 font-display text-xl font-extrabold leading-tight tracking-tight text-ink" data-id="element-419" data-mp="25kgwi5wm4zk7">{tome.title}</h3>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-widest text-coral-deep" data-id="element-420" data-mp="l1wj2dj1ig70">{tome.range}</p>
              <p className="mt-2 text-sm text-slate" data-id="element-421" data-mp="q2k8iurmeoz4">{tome.promise}</p>
              <ul className="mt-4 grid gap-2 border-t border-cloud-dark pt-4" data-id="element-422" data-mp="bas43dtd6vc6">
                {tome.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-ink" data-id="element-423" data-mp="g8leyk5m4dis">
                    <span className={`mt-[7px] h-1.5 w-1.5 flex-none rounded-full ${tome.badge}`} data-id="element-424" data-mp="29bzjmp8dnfv" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <div className="mt-6 rounded-2xl bg-ink px-5 py-5 text-white sm:px-7" data-id="element-425" data-mp="3th6krkj0pje9">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-amber" data-id="element-426" data-mp="3tjalxupj84au">In every volume</p>
          <ul className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-4" data-id="element-427" data-mp="1moxdimccjxew">
            {everyVolume.map(item => <li key={item} className="flex gap-2 text-[13px] text-white/85" data-id="element-428" data-mp="1q8nznd5k78xy">
                <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-teal" data-id="element-429" data-mp="1q6bbgi97k2cg" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}